<!--模板-->
<template>
  <div id="foot">
    <!-- >>>底部区域-->
    <div class="footer" id="newfoot">
      <div class="wrapper">
        <div class="footer_wrap clearfix">
          <div class="footer_Left">
            <h2>官方微博</h2>
            <iframe
              class="share_self"
              src="../../../static/images/imgsrc/xsjwbx.html"
              width="365px"
              height="464px"
            ></iframe>
          </div>
          <div class="footer_Line"></div>
          <div class="footer_Right">
            <h2>推荐行业</h2>
            <ul class="partner">
              <li>
                <a href="http://www.aliyun.com" target="_blank"
                  ><img src="../../../static/images/imgsrc/hezuo01.jpg"
                /></a>
                <span>阿里云服务</span>
              </li>
              <li>
                <a href="http://www.mafengwo.cn" target="_blank"
                  ><img src="../../../static/images/imgsrc/hezuo02.jpg"
                /></a>
                <span>马蜂窝</span>
              </li>
              <li>
                <a href="http://www.ctrip.com/" target="_blank"
                  ><img src="../../../static/images/imgsrc/hezuo03.jpg"
                /></a>
                <span>携程旅游</span>
              </li>
              <li>
                <a href="http://www.tuniu.com/" target="_blank"
                  ><img src="../../../static/images/imgsrc/hezuo04.jpg"
                /></a>
                <span>途牛旅游</span>
              </li>
              <li>
                <a href="https://www.alitrip.com/" target="_blank"
                  ><img src="../../../static/images/imgsrc/hezuo05.jpg"
                /></a>
                <span>阿里旅行</span>
              </li>
              <li>
                <a href="http://www.ly.com/" target="_blank"
                  ><img src="../../../static/images/imgsrc/hezuo06.jpg"
                /></a>
                <span>同程旅游</span>
              </li>
              <li>
                <a href="http://www.qunar.com/" target="_blank"
                  ><img src="../../../static/images/imgsrc/hezuo07.jpg"
                /></a>
                <span>去哪儿</span>
              </li>
              <li>
                <a href="https://zh.airbnb.com/" target="_blank"
                  ><img src="../../../static/images/imgsrc/hezuo08.jpg"
                /></a>
                <span>Airbnb民宿</span>
              </li>
              <li>
                <a href="http://www.airasia.com/cn/zh/home.page" target="_blank"
                  ><img src="../../../static/images/imgsrc/hezuo09.jpg"
                /></a>
                <span>亚洲航空</span>
              </li>
              <li>
                <a href="http://www.qyer.com/" target="_blank"
                  ><img src="../../../static/images/imgsrc/hezuo10.jpg"
                /></a>
                <span>穷游</span>
              </li>
              <li>
                <a href="http://www.lvye.cn/" target="_blank"
                  ><img src="../../../static/images/imgsrc/hezuo11.jpg"
                /></a>
                <span>绿野户外</span>
              </li>
              <li>
                <a href="http://www.agoda.com/zh-cn" target="_blank"
                  ><img src="../../../static/images/imgsrc/hezuo12.jpg"
                /></a>
                <span>Agoda酒店预定</span>
              </li>
            </ul>
            <div class="line-horizontal"></div>
            <h2>企业资质</h2>
            <ul class="partner">
              <li>
                <a
                  href="http://www.gsxt.gov.cn/index.html?uniscid=91370800MA3Q2DYJ48"
                  target="_blank"
                  ><img src="../../../static/images/imgsrc/zz01.png"
                /></a>
                <span>企业资质</span>
              </li>
              <!--                <li>-->
              <!--                  <a href="http://koubei.baidu.com/s/www.peibanwan.com"target="_blank"><img src="../../../static/images/imgsrc/zz02.png" /></a>-->
              <!--                  <span>百度信誉</span>-->
              <!--                </li>-->
              <!--                <li>-->
              <!--                  <a href="http://qyxy.baic.gov.cn/xycx/queryCreditAction!qyxq_view.dhtml?reg_bus_ent_id=ff80808153845619015388b1bec10a38&credit_ticket=45F7E8CD0BFAF6C4732FECAC3A7B8FD4"target="_blank"><img src="../../../static/images/imgsrc/zz03.png" /></a>-->
              <!--                  <span>实名验证</span>-->
              <!--                </li>-->
              <!--                <li>-->
              <!--                  <a href="http://qyxy.baic.gov.cn/xycx/queryCreditAction!qyxq_view.dhtml?reg_bus_ent_id=ff80808153845619015388b1bec10a38&credit_ticket=45F7E8CD0BFAF6C4732FECAC3A7B8FD4"target="_blank"><img src="../../../static/images/imgsrc/zz04.png" /></a>-->
              <!--                  <span>可信网站</span>-->
              <!--                </li>-->
            </ul>
          </div>
        </div>
        <div class="line-horizontal"></div>
        <div class="wrap"></div>
        <div class="footer_wrap clearfix mt20">
          <dl class="footer_wrap_list">
            <dt><i class="iconfont icon-app"></i></dt>
            <dd>【APP下载】<br />搜索"陪伴玩"</dd>
            <dd class="qrcode qrcode_weixin"></dd>
          </dl>
          <dl class="footer_wrap_list">
            <dt><i class="iconfont icon-erweima-copy"></i></dt>
            <dd>【微信公众号】<br />@陪伴玩wan</dd>
            <dd class="qrcode"></dd>
          </dl>
          <dl class="footer_wrap_list">
            <dt><i class="iconfont icon-xiaochengxu"></i></dt>
            <dd>【微信小程序】<br />@陪伴玩wan</dd>
            <dd class="qrcode qrcode_xiaochengxu"></dd>
          </dl>
          <dl class="footer_wrap_list">
            <dt><i class="iconfont icon-rexian"></i></dt>
            <dd>【客服热线】<br />+86</dd>
          </dl>
        </div>
        <div class="line-horizontal"></div>
      </div>
      <div class="wrap wrap-contact">
        <div class="copyright">
          <p class="copyright-links">
            <a @click="$router.push('/about?type=0')" class="white">帮助中心</a>
            |
            <a @click="$router.push('/about?type=6')" class="white">关于我们</a>
            |
            <a @click="$router.push('/about?type=1')" class="white">用户协议</a>
            |
            <a @click="$router.push('/about?type=2')" class="white">隐私政策</a>
            |
            <a @click="$router.push('/about?type=5')" class="white">免责声明</a>
            |
          </p>
          © 2021 陪伴玩 peibanwan.com 版权所有 济宁智摆数字技术有限公司
          <span @click="icp" style="cursor: pointer">鲁ICP备19036305号-2</span
          >&nbsp;
          <!-- <span @click="gong" style="cursor: pointer"
            >公网安备37089702000361号</span
          >&nbsp; -->
          <span @click="fang" style="cursor: pointer">统计</span>
        </div>
      </div>
    </div>
  </div>
</template>

<!--JS-->
<script>
export default {
  data() {
    return {};
  },
  methods: {
    gong() {
      window.open(
        "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37089702000361"
      );
    },
    icp() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
    fang() {
      location.href =
        "https://web.umeng.com/main.php?c=site&a=frame&siteid=1257134912";
    },
  },
};
</script>

<!--css样式-->
<style lang="scss" scoped>
@import "../../../src/scss/commonH5.scss";
@import "../../scss/demo.scss";
.footer {
  background: #242222;
  color: #fff;
  padding: 30px 0;
  width: 100%;
}
.footer .wrapper {
  position: relative;
  width: 1200px;
  margin: 0 auto;
}
.wrap-contact {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
}
.footer .footer_Left,
.footer .footer_Right {
  float: left;
  overflow: hidden;
}
.footer .footer_Left {
  width: 370px;
}
.footer h2 {
  display: inline-block;
  background: #353030;
  line-height: 40px;
  border-radius: 20px;
  padding: 0 20px;
  color: #ffffff;
  margin: 30px auto;
  font-size: 20px;
}
.footer .footer_Line {
  position: absolute;
  width: 1px;
  background: #171515;
  border-right: 1px solid #353030;
  left: 401px;
  top: 30px;
  height: 464px;
}
.footer .footer_Right {
  width: 725px;
  margin-left: 65px;
}
.footer .footer_Right .partner {
  margin: 0 0 0 -14px;
  width: 752px;
  overflow: hidden;
  list-style: none;
}
.footer .footer_Right .partner li {
  float: left;
  width: 160px;
  margin: 0 14px 14px;
  padding: 0;
  text-align: center;
  color: #7e7d7d;
}
.footer .footer_Right .partner li a {
  position: relative;
  width: 160px;
  height: 50px;
  display: block;
}
.footer .footer_Right .partner li a img {
  width: 155px;
  height: 48px;
  border-radius: 5px;
  -webkit-border-radius: 5px;
}
.footer .footer_Right .partner li a:hover img {
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.footer .footer_Right .partner li span {
  margin-top: 8px;
  display: block;
  width: 160px;
  height: 20px;
  overflow: hidden;
}
.share_self {
  background: #434343;
  overflow: hidden;
  border-radius: 5px;
  -webkit-border-radius: 5px;
}
.footer .footer_wrap_list {
  width: 25%;
  color: #fff;
  height: 70px;
  position: relative;
  float: left;
  padding: 30px 0;
}
.footer .footer_wrap_list dt {
  float: left;
  background: #353030;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  text-align: center;
  line-height: 67px;
  margin-left: 73px;
}
.footer .footer_wrap_list dt .iconfont {
  color: #dadada;
  font-size: 38px;
  cursor: default;
}
.footer .footer_wrap_list dd {
  float: left;
  margin-left: 10px;
  line-height: 25px;
  margin-top: 10px;
}
.footer_wrap_list:hover {
  .qrcode {
    display: inline-block !important;
  }
}
.footer .footer_wrap_list dd.qrcode {
  background: url(../../../static/images/imgsrc/weixin.png) no-repeat;
  width: 220px;
  height: 312px;
  position: absolute;
  bottom: 110px;
  left: -10px;
  display: none;
}
.footer .footer_wrap_list dd.qrcode_weixin {
  background: url(../../../static/images/imgsrc/app.png) no-repeat;
}
.footer .footer_wrap_list dd.qrcode_xiaochengxu {
  background: url(../../../static/images/imgsrc/wechat.png) no-repeat;
}
.line-horizontal {
  height: 1px;
  background: #171515;
  border-bottom: 1px solid #353030;
  clear: both;
}
.wrap {
  width: 1100px;
  margin-left: auto;
  margin-right: auto;
}
.copyright {
  line-height: 1.75;
  text-align: center;
  font-size: 12px;
  color: #fff;
  margin: 20px 0;
}
.copyright a {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footers.vue